import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import useToastStore from '@/store/toast';

const ToastProvider: React.FC = () => {
  const toasts = useToastStore(state => state.toasts);

  return (
    <div className="fixed left-1/2 top-4 z-[100] w-full -translate-x-1/2 transform space-y-2 md:w-auto">
      <AnimatePresence>
        {toasts.map(toast => (
          <motion.div
            key={toast.id}
            layout
            initial={{ opacity: 0, y: -40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -40 }}
            transition={{ duration: 0.3 }}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            className="alert alert-info mx-auto flex w-full max-w-sm !items-center border-none bg-card text-center text-xs text-white shadow-lg"
          >
            <img src={`/icons/${toast.icon ?? 'info'}.svg`} alt="info" />
            {toast.message}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ToastProvider;
